// extracted by mini-css-extract-plugin
export default {"container":"styles_container__EGBCe","content":"styles_content__UtYYy"};